module.exports = __webpack_public_path__ + "static/media/disha_kadam.32a64269.png";